/* ============
 * City Module Mutations
 * ============
 */

import {
  FETCH_CITIES,
} from './../../mutation-types';

export default {
  [FETCH_CITIES](state, { cities }) {
    state.all = cities;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/city/mutations.js